import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    signature: Yup.string().required(),
    signatureDate: Yup.string().nullable().required(),
    requireTranslator: Yup.boolean(),
    translatorName: Yup.string().when('requireTranslator', {
        is: true,
        then: Yup.string().nullable().required("Translator Name is required"),
        otherwise: Yup.string().nullable()
    }),
    translatorSignature: Yup.string().when('requireTranslator', {
        is: true,
        then: Yup.string().nullable().required("Translator Signature is required"),
        otherwise: Yup.string().nullable()
    })
});